import { TENURE_RANGES } from 'features/command-center/constants';
import { capitalizeName } from 'features/command-center/utils';
import startCase from 'lodash/startCase';
import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';
import { OVERALL_PERFORMNACE_METRICS } from 'UI/pages/CommandCenter/OverallPerformance';
import { convertMinutesToSeconds, roundDecimals } from 'UI/utils';

export const generateFinalEndpoint = endpoint => {
  const [baseUrl, queryString] = endpoint.split('?');
  const params = new URLSearchParams(queryString);
  const originalMetrics = params.get('metrics') || '';
  const originalMetricsArray = originalMetrics ? originalMetrics.split(',') : [];
  const customMetrics = OVERALL_PERFORMNACE_METRICS.split(',').filter(
    metric => !originalMetricsArray.includes(metric)
  );
  const finalMetrics = originalMetricsArray.concat(customMetrics).join(',');

  params.set('metrics', finalMetrics);
  return `${baseUrl}?${params.toString()}`.replace(/%2C/g, ',');
};

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    recruiterName: {
      empNo: item.empNo,
      name: capitalizeName(item?.name)
    },
    team: {
      managerEmpNo: item.managerEmpNo,
      team: capitalizeName(item?.team)
    },
    inMails: {
      inMails: item.inMails,
      inMailsGoals: item.inMailsGoals
    },
    avgInMails: {
      avgInMails: item.avgInMails,
      avgInMailsGoals: item.avgInMailsGoals
    },
    bulks: {
      bulks: item.bulks,
      bulksGoal: item.bulksGoal
    },
    callsTime: {
      callsTime: item.callsTime,
      callsTimeGoal: item.callsTimeGoal
    },
    calls: {
      callsTime: item?.callsTime ? convertMinutesToSeconds(item?.callsTime) : 0,
      callsTimeGoal: item?.callsTimeGoal ? convertMinutesToSeconds(item.callsTimeGoal) : 0
    },
    peopleReached: {
      peopleReached: item.peopleReached,
      peopleReachedGoal: item.peopleReachedGoal
    },
    posts: {
      todayLivePosts: item.todayLivePosts,
      livePostingsDailyGoal: item.livePostingsDailyGoal
    },
    sendouts: {
      sendouts: item.sendouts,
      sendoutsGoal: item.sendoutsGoal
    },
    productionYTD: item.productionYtd,
    cashInYTD: item.cashInYtd,
    outStandingBillings: item.outstandingBillings,
    hireDate: item?.hireDate && moment(item?.hireDate).format(DateFormats.SimpleDate),
    tenure: item?.tenure ? TENURE_RANGES[item.tenure] : null,
    lastFeedbackActivityType:
      item?.lastFeedbackActivityType && startCase(item?.lastFeedbackActivityType),
    avgFeePercentage: item?.avgFeePercentage && roundDecimals(item?.avgFeePercentage, 2)
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
